import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { IBaseEcg } from "../../../models/base-ecg.interface";
import ecgsService from "../../../services/ecgs.service";
import { Loader } from "@shltelemedicine/shl-ui-lib";
import UserEcgListItem from "./UserEcgListItem/UserEcgListItem";

type UserEcgsListProps = {
  selectedEcgId?: string | null;
  selectedPatientId: string | null;
  onSelectEcg?: (ecg: IBaseEcg) => void;
};

const UserEcgsList = ({
  selectedPatientId,
  selectedEcgId,
  onSelectEcg,
}: UserEcgsListProps) => {
  const [loading, setLoading] = useState(false);
  const [ecgs, setEcgs] = useState<IBaseEcg[]>([]);

  const selectHandler = (ecg: IBaseEcg) => {
    if (ecg && onSelectEcg) onSelectEcg(ecg);
  };

  useEffect(() => {
    (async () => {
      if (!selectedPatientId) return;
      setLoading(true);
      const data = await ecgsService.getEcgsByPatientId(selectedPatientId);
      setEcgs(data ?? []);
      setLoading(false);
    })();
  }, [selectedPatientId]);

  return (
    <div
      style={{ border: "2px solid #d5d8e2" }}
      className="h-100 d-flex flex-column overflow-auto"
    >
      <p className="p-2 mb-2 muted-color font-md font-weight-bold">
        {ecgs?.length ? (
          <FormattedMessage id="ECG_LIST.TITLE" defaultMessage="ALL ECG" />
        ) : (
          <FormattedMessage
            id="ECG_LIST.EMPTY.TITLE"
            defaultMessage="Patient ECG will show here"
          />
        )}
      </p>
      {loading ? (
        <div className="py-3">
          <Loader />
        </div>
      ) : (
        <div className="flex-grow-1">
          {ecgs?.map((ecg) => (
            <UserEcgListItem
              key={ecg.id}
              patientId={selectedPatientId}
              ecg={ecg}
              selected={selectedEcgId === ecg.id}
              onClick={selectHandler}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default UserEcgsList;
